module.exports = __webpack_public_path__ + "72a1eefb93f9feacca656dbfb01d8eab.svg";